import { observer } from 'mobx-react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import CheckIcon from '@mui/icons-material/Check';
import { Box, Typography } from '@mui/material';
// import Avatar from 'components/Avatar';
import MediaTypography from 'components/MediaTypography';

import { INotificationModel } from '@common/models/Notifications/Notification';

import NotificationItemPlug from './Plug';
import * as Styled from './styled';

interface NotificationListItemProps {
	notification: INotificationModel;
	openVerificationModal?: (value: boolean) => void;
}

function NotificationListItem({ notification, openVerificationModal }: NotificationListItemProps) {
	const { t } = useTranslation();
	const showImportantPart = notification.is_important && !notification.isReaded;
	const notificationMeta = notification?.meta?.type;
	const isEmailVerification = notificationMeta === 'verification_email';

	return (
		<Styled.Wrap isImportant={showImportantPart} isReaded={notification.isReaded}>
			{showImportantPart && <NotificationItemPlug />}
			<Styled.Header>
				{/* <Avatar
					// src={cover_url}
					alt="Avatar"
					{...(!notification.isReaded && { badgeProps: { color: 'error' }, badgeContent: <></> })}
				/> */}
				<Box display="flex" flexDirection="column">
					<MediaTypography
						variants={{ sm: 'subtitle2' }}
						variant="subtitle1"
						lineClamp={{ default: 1 }}
					>
						{notification.title}
					</MediaTypography>
					{!showImportantPart && (
						<Styled.StyledMediaTypography
							variant="caption1"
							dangerouslySetInnerHTML={{ __html: notification.message }}
						/>
					)}
				</Box>
				{!notification.is_important && !notification.isReaded && (
					<Styled.CloseButton onClick={notification.read} background size="small" />
				)}
			</Styled.Header>
			{showImportantPart && (
				<>
					<Styled.Main>
						<MediaTypography
							variants={{ sm: 'body3' }}
							variant="body2"
							textColor="secondary"
							component="p"
							dangerouslySetInnerHTML={{ __html: notification.message }}
						/>
					</Styled.Main>
					<Styled.ConfirmButton
						variant="contained"
						color="primary"
						fullWidth
						onClick={async () => {
							if (isEmailVerification) {
								openVerificationModal(true);
							}

							await notification.read();
						}}
					>
						<CheckIcon />
						{notificationMeta ? t('shared.verifyYourself') : t('shared.confirm')}
					</Styled.ConfirmButton>
				</>
			)}
			<Styled.DateWrap>
				<Typography variant="caption2" color="text.helper">
					{notification.dateString}
				</Typography>
				<Typography variant="caption2" color="text.helper">
					{notification.timeString}
				</Typography>
			</Styled.DateWrap>
		</Styled.Wrap>
	);
}

export default observer(NotificationListItem);
